/* eslint-disable import/extensions */
import Auth0PreLoginHandlerChangePassword from './implementations/auth0-pre-login-handler-change-password.mjs';
import Auth0PreLoginHandlerVerifyEmail from './implementations/auth0-pre-login-handler-verify-email.mjs';
import Auth0PreLoginHandlerMfa from './implementations/auth0-pre-login-handler-mfa.mjs';
import Auth0PreLoginHandlerSmsCollection from './implementations/auth0-pre-login-handler-sms-collection.mjs';
import Auth0PreLoginHandlerMfaChoice from './implementations/auth0-pre-login-handler-mfa-choice.mjs';
import Auth0PreLoginHandlerAccountLinking from './implementations/auth0-pre-login-handler-account-linking.mjs';


const registeredHandlers = [
  {
    handlerName: 'Account Linking Handler',
    handlerDescription: 'Handles pre login logic for admin-initiated account linking flow',
    HandlerClass: Auth0PreLoginHandlerAccountLinking,
  },
  {
    handlerName: 'Change Password Handler',
    handlerDescription: 'Handles pre login logic for user engaging the password recovery flow',
    HandlerClass: Auth0PreLoginHandlerChangePassword,
  },
  {
    handlerName: 'Verify Email Handler',
    handlerDescription: 'Handles pre login logic for user engaging in email verification flow',
    HandlerClass: Auth0PreLoginHandlerVerifyEmail,
  },
  {
    handlerName: 'MFA Handler',
    handlerDescription: 'Handles pre login logic for that must enter an MFA TOP or code in order to continue to app',
    HandlerClass: Auth0PreLoginHandlerMfa,
  },
  {
    handlerName: 'Sms Collection Handler',
    handlerDescription: 'Handles pre login logic to collect an sms number from the user',
    HandlerClass: Auth0PreLoginHandlerSmsCollection,
  },
  {
    handlerName: 'MFA Choice Handler',
    handlerDescription: 'Handles pre login logic to let the user choose which mfa factor to challenge to complete login',
    HandlerClass: Auth0PreLoginHandlerMfaChoice,
  },
];

export default {
  registeredHandlers,
  handlerFromConfig: (handlerType, options) => {
    const handlerData = registeredHandlers.filter(h => h.HandlerClass === handlerType).pop();
    return new handlerData.HandlerClass({
      ...options,
      name: handlerData.name,
      description: handlerData.description,
    });
  },
};
